import { isArray as g } from "./index575.js";
import { isElement as x } from "./index565.js";
import { isClient as E } from "./index599.js";
const o = /* @__PURE__ */ new Map();
if (E) {
  let e;
  document.addEventListener("mousedown", (t) => e = t), document.addEventListener("mouseup", (t) => {
    if (e) {
      for (const n of o.values())
        for (const { documentHandler: s } of n)
          s(t, e);
      e = void 0;
    }
  });
}
function i(e, t) {
  let n = [];
  return g(t.arg) ? n = t.arg : x(t.arg) && n.push(t.arg), function(s, a) {
    const r = t.instance.popperRef, c = s.target, d = a?.target, l = !t || !t.instance, f = !c || !d, p = e.contains(c) || e.contains(d), m = e === c, h = n.length && n.some((u) => u?.contains(c)) || n.length && n.includes(d), v = r && (r.contains(c) || r.contains(d));
    l || f || p || m || h || v || t.value(s, a);
  };
}
const y = {
  beforeMount(e, t) {
    o.has(e) || o.set(e, []), o.get(e).push({
      documentHandler: i(e, t),
      bindingFn: t.value
    });
  },
  updated(e, t) {
    o.has(e) || o.set(e, []);
    const n = o.get(e), s = n.findIndex(
      (r) => r.bindingFn === t.oldValue
    ), a = {
      documentHandler: i(e, t),
      bindingFn: t.value
    };
    s >= 0 ? n.splice(s, 1, a) : n.push(a);
  },
  unmounted(e) {
    o.delete(e);
  }
};
export {
  y as default
};
